import { Typography } from '@mui/material';
import { FC } from 'react';

interface TitleTextProps {
    text: string;
}

export const TitleText: FC<TitleTextProps> = ({ text }) => {
    return <Typography variant="h2">{text}</Typography>;
};
